(function () {
	'use strict';
	angular.module('mx.SolutionBuilderAgent').component('mxConditionsBuilder', {
		bindings: {
			conditionsBuilder: '<',
		},
		controller: MxConditionsBuilderCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-condition-builder/mx-conditions-builder.html',
	});

	MxConditionsBuilderCtrl.$inject = ['$scope'];

	function MxConditionsBuilderCtrl($scope) {
		let vm = this;
		vm.searchText = '';

		vm.$onInit = () => {
			if (vm.conditionsBuilder) {
				vm.initialized = true;
			} else {
				mx.console.warn('no conditions builder');
			}
		};

		$scope.$watch('vm.searchText', (newValue) => {
			if (vm.initialized) {
				vm.conditionsBuilder.setFilterForProperties(newValue);
			}
		});
	}
})();
